require('./_set-species')('Array');


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/es6.array.species.js
 **/